export default __webpack_public_path__ + "static/media/CV.46937889.svg";